import { useState } from "react";
import Navbar from "../home/components/Navbar";
import Footer from "../home/components/Footer";
import { getDailyVerse } from "../../mocks/dailyVerses";
import { getDailyLesson, DAILY_LESSONS } from "../../mocks/dailyLessons";
import { Link } from "react-router-dom";

export default function DevotionalsPage() {
  const today = new Date();
  const verse = getDailyVerse(today);
  const lesson = getDailyLesson(today);
  const [expandedLesson, setExpandedLesson] = useState<number | null>(0);

  const dateLabel = today.toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
  });

  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <Navbar />

      <div className="max-w-4xl mx-auto px-4 md:px-6 pt-24 pb-20">
        {/* Header */}
        <div className="mb-10">
          <p className="text-[#ef4444] text-xs font-medium uppercase tracking-widest mb-2">
            {dateLabel}
          </p>
          <h1 className="text-2xl md:text-3xl font-bold text-white mb-2">Daily Devotionals</h1>
          <p className="text-[#555] text-sm">Fresh Scripture and reflection — new every day</p>
        </div>

        {/* Verse of the Day */}
        <div className="bg-[#111] border border-[#1e1e1e] rounded-xl p-7 mb-6">
          <p className="text-[#ef4444] text-xs font-medium uppercase tracking-widest mb-5">
            Verse of the Day
          </p>
          <blockquote className="text-white text-xl md:text-2xl leading-relaxed font-light mb-5">
            &ldquo;{verse.text}&rdquo;
          </blockquote>
          <p className="text-[#555] text-sm mb-5">
            &mdash; {verse.reference} ({verse.translation})
          </p>
          <Link
            to="/scripture"
            className="inline-flex items-center gap-1.5 text-[#ef4444] text-sm hover:gap-2.5 transition-all cursor-pointer"
          >
            Open in Bible Reader <i className="ri-arrow-right-line" />
          </Link>
        </div>

        {/* Today's Lesson — featured */}
        <div className="bg-[#111] border border-[#ef4444]/20 rounded-xl p-7 mb-8">
          <div className="flex items-center gap-2 mb-4">
            <p className="text-[#ef4444] text-xs font-medium uppercase tracking-widest">
              Today&apos;s Lesson
            </p>
            <span className="text-[#2e2e2e]">&middot;</span>
            <span className="text-[#555] text-xs">{lesson.passage}</span>
          </div>
          <h2 className="text-xl md:text-2xl font-bold text-white mb-3">{lesson.title}</h2>
          <p className="text-[#777] text-sm leading-relaxed mb-5">{lesson.summary}</p>
          <div className="space-y-3 mb-5">
            {lesson.points.map((pt) => (
              <div key={pt} className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-checkbox-circle-line text-[#ef4444]" />
                </div>
                <p className="text-[#888] text-sm leading-relaxed">{pt}</p>
              </div>
            ))}
          </div>
          <div className="border-t border-[#1e1e1e] pt-5">
            <p className="text-[#ef4444] text-xs font-medium uppercase tracking-widest mb-2">
              Reflection Question
            </p>
            <p className="text-[#666] text-sm italic">&ldquo;{lesson.reflection}&rdquo;</p>
          </div>
        </div>

        {/* All lessons library */}
        <div>
          <h2 className="text-lg font-bold text-white mb-4">Lesson Library</h2>
          <div className="space-y-2">
            {DAILY_LESSONS.map((l, i) => (
              <div
                key={l.title}
                className="bg-[#111] border border-[#1e1e1e] rounded-xl overflow-hidden"
              >
                <button
                  onClick={() => setExpandedLesson(expandedLesson === i ? null : i)}
                  className="w-full flex items-start justify-between gap-4 px-5 py-4 cursor-pointer hover:bg-[#161616] transition-colors text-left"
                >
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 flex items-center justify-center bg-[#1a1a1a] border border-[#2e2e2e] rounded-lg flex-shrink-0 mt-0.5">
                      <i className="ri-book-open-line text-[#ef4444] text-xs" />
                    </div>
                    <div>
                      <p className="text-white text-sm font-medium">{l.title}</p>
                      <p className="text-[#555] text-xs mt-0.5">{l.passage}</p>
                    </div>
                  </div>
                  <i
                    className={`ri-arrow-${expandedLesson === i ? "up" : "down"}-s-line text-[#444] flex-shrink-0 mt-1`}
                  />
                </button>
                {expandedLesson === i && (
                  <div className="px-5 pb-5 border-t border-[#1a1a1a]">
                    <p className="text-[#666] text-sm leading-relaxed mt-4 mb-4">{l.summary}</p>
                    <div className="space-y-2 mb-4">
                      {l.points.map((pt) => (
                        <div key={pt} className="flex items-start gap-2">
                          <i className="ri-checkbox-circle-line text-[#ef4444] text-xs mt-1 flex-shrink-0" />
                          <p className="text-[#777] text-xs leading-relaxed">{pt}</p>
                        </div>
                      ))}
                    </div>
                    <div className="border-t border-[#1a1a1a] pt-4">
                      <p className="text-[#444] text-xs italic">&ldquo;{l.reflection}&rdquo;</p>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
